(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name greatCircleDistance.controller:GreatCircleDistanceCtrl
	 *
	 * @description
	 *
	 */
	angular
		.module('messageInbox')
		.controller('MessageInboxCtrl', MessageInboxCtrl);

	function MessageInboxCtrl(CommonMasterData, PopupManager, EventManagerService, applicationConstants,
			MessageInboxService, MessageService, $timeout, MessageInboxFactory, AlertManagerService, $window) {
		var vm = this;
		//70 (title bar height) + 40 (toolbar height)
		var heightSearchPanel = 70 + angular.element('.toolbar').height();
		//70 (title bar height) + 40 (toolbar height)+ 47 (grid table header height)
		var heightGridData = 70 + angular.element('.toolbar').height() + 47;
		var rowHeight = 50;
		vm.selectedMessageStatus = null;
		vm.selectedMessageRowSelect= null;
		vm.showRightPanel = false;
		vm.model = {
			searchPanelToggle : true,
			editorMode : applicationConstants.EDITOR_STATUS.DELETE,
			searchCriteria : {
				fromDate : moment(new Date()).format('DD/MM/YYYY'),
				toDate : moment(new Date()).format('DD/MM/YYYY'),
				category : "",
				crewType : "",
				sentBy : "",
				sentByUserId : "",
				title : "",
				includeReadMsgs : true,
				disableCrewType : false,
                pageSize : Math.ceil(screen.height / rowHeight) * 3,
				startPosition : 1,
				NameTitle : "Crew Name",
        messageContent : ""
			},
			masterList : {
				sentByList : [],
				messageCategoryList : [],
				crewTypes : [],
				usersList : [],
				canvasHeight : $window.innerHeight - heightGridData,
				//70 (Side panel)
				canvasWidth : $window.innerWidth - 70,
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
			},
			messagesData : [],
		};

		angular.element($window).bind('resize', function(){
            $timeout(function () {
            	angular.element('.search-panel').css("max-height", $window.innerHeight - heightSearchPanel);
            	vm.model.masterList.canvasHeight = $window.innerHeight - heightGridData;
            	vm.model.masterList.canvasWidth = $window.innerWidth - 70;

            },0);
        });

		EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

		// to hide and show search panel
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
		};

		vm.submitSearch = function(searchParams) {
			if(isValidSearchParams()) {
				document.querySelector('.elastic_div').scrollTop = 0;
				vm.model.searchCriteria = searchParams;
				vm.selectedMessageStatus = null;
				vm.selectedMessageRowSelect = null;
				vm.model.searchCriteria.startPosition = 1;
				vm.clickOnClose();
				getMessageList();
			}
		};

		vm.clickOnAction = function(selectedRowData) {
        selectedRowData.readStatus = true;
        vm.selectedMessageStatus = selectedRowData;
				vm.showRightPanel = true;
				if(vm.selectedMessageStatus != null && vm.selectedMessageStatus.messageId != selectedRowData.messageId) {
					vm.selectedMessageStatus.readStatus = false;
				}
				vm.selectedMessageRowSelect = selectedRowData;
				vm.selectedMessageRowSelect.isSelected = true;
      vm.selectedMessageRowSelect.messageContent = strip(selectedRowData.content);
				vm.model.rightPanelTitle = selectedRowData.title;

		};

    function strip(html) {
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "" ;

    }

		vm.submitMessage = function(action, selectedItem) {
			if (action === applicationConstants.EDITOR_STATUS.DELETE) {
				onMessageDelete(selectedItem);
			} else if(action == "CLOSE") {
				vm.clickOnClose();
			}else if (action == "REPLY"){
			  vm.clickOnReply();
      }else if(action == "MARK_AS_READ"){
			  vm.clickOnMarkAsRead()
      }
		};

		vm.changeSearchField = function(searchParams, flag) {
			if (flag == "sentBy") {
				vm.model.masterList.usersList = [];
				if (searchParams.sentBy == undefined) {
					vm.model.searchCriteria.crewType = undefined;
					vm.model.searchCriteria.sentByUserId = undefined;
					return;
				}
				if (searchParams.sentBy.value == "Other") {
					vm.model.searchCriteria.NameTitle = "User Name";
					vm.model.searchCriteria.disableCrewType = true;
					loadNonCrewList();
				} else {
					vm.model.searchCriteria.NameTitle = "Crew Name"
					vm.model.searchCriteria.disableCrewType = false;
					loadCrewTypes();
				}
			} else if (flag == "crewType") {
				loadCrewList();
			} else if (flag == "fromDate") {
				setDateValidationFlags();
				if (vm.model.searchCriteria.fromDate) {
                    var moEnd = moment(vm.model.searchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT).endOf("month");
                    vm.model.searchCriteria.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
                }
			}
		};

		vm.clickOnClose = function() {
			vm.showRightPanel = false;
		};

		vm.clickOnReply = function() {
			var modalParams = {
				selectedMessage : vm.selectedMessageStatus,
				maxCharactersInMSG : vm.maxCharactersInMSG
			};
			PopupManager.openModal('REPLY', modalParams, function(param){
            	 if (!!param) {
            		vm.selectedMessageStatus.readStatus = false;
            	 }
             });
		};

		vm.clickOnMarkAsRead = function(flag,operation,item) {
			if(vm.selectedMessageStatus.read) {
				MessageService.warning('Message already marked as Read');
				return;
			}
			MessageInboxService.markAsRead(vm.selectedMessageStatus, function(response) {
				if(response.success) {
					MessageService.success('Message marked as Read');
					vm.selectedMessageStatus.readStatus = false;
					vm.submitSearch(vm.model.searchCriteria);
				}
			}, function(error) {
				MessageService.error(error);
			});
		};

		function onMessageDelete(selectedItem) {
			var details = {
					title: 'Confirmation',
					messages: ['Message will be Deleted. Do you wish to Continue?']
			};
			PopupManager.openModal('CONFIRM_DIALOG', details, function(param){
				if (!!param) {
					MessageInboxService.deleteMessage(selectedItem.messageId, function(response) {
						vm.submitSearch(vm.model.searchCriteria);
						MessageService.success('Message deleted Successfully');
					}, function(error) {
						MessageService.error(error);
					});
				}
			});
		}

		function isValidSearchParams() {
			setDateValidationFlags();
			// if date invalid
			if(!isFromDateBeforeToDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}

			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid
					|| vm.model.masterList.fromDateAfterToDate) {
				return false;
			} else {
				return true;
			}
		}

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}
			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		// check from date and to date
		function isFromDateBeforeToDate() {
			return moment(vm.model.searchCriteria.fromDate,"DD/MM/YYYY").isBefore( moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY"))
			|| moment(vm.model.searchCriteria.fromDate,"DD/MM/YYYY").isSame(moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY"));
		};

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}


		function loadCrewList() {
            var param = {};
            param.crewType = vm.model.searchCriteria.crewType.crewTypeCode;
            param.active = true;
            CommonMasterData.loadCrewList(param,
                function (response) {
                    vm.model.masterList.usersList = MessageInboxService.adaptCrewList(response);
                },
                function () {
                    console.log('Crew list retrieval error');
                }
            );
		}

		function loadCrewTypes() {
            CommonMasterData.getCrewTypeList(
                function (crewTypes) {
                    vm.model.masterList.crewTypes = crewTypes;
                },
                function () {
                    console.log('Crew type retrieval error');
                }
            );
        }

		function loadNonCrewList() {
            CommonMasterData.getNonCrewUserList(
                function (nonCrewList) {
                    vm.model.masterList.usersList = nonCrewList;
                },
                function () {
                    console.log('Non Crew List retrieval error');
                }
            );
        }

		// load grid data
		function getMessageList() {
			MessageInboxService.searchMessageInbox(vm.model.searchCriteria, function(messagesData) {
				vm.model.messagesData = MessageInboxFactory.getFormattedMessageList(messagesData, vm.prioritiesList);
				vm.model.searchPanelToggle = false;
			}, function(error) {
				MessageService.error(error);
			});
		};

		function getMaxCharCountInSentMsg() {
			AlertManagerService.getSendMsgMaxCharacterCount(function(charCount) {
				vm.maxCharactersInMSG = charCount === null ? 0 : charCount.paramValue;
				},
				function() {
					console.log('App Param Send Msg Character Count retrieval error');
			});
		};

		function getNextSetOfRecords() {
			if (vm.model.messagesData &&
	                vm.model.messagesData.totalRecords &&
	                vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize < vm.model.messagesData.totalRecords
	            ) {
	                vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize;
	                getDataForElasticSearch();
	            }
			else {
				var lastPageStartPos = vm.model.messagesData.totalRecords - vm.model.searchCriteria.pageSize;
                if (vm.model.searchCriteria.startPosition < lastPageStartPos) {
                    vm.model.searchCriteria.startPosition = lastPageStartPos;
                    getDataForElasticSearch();
                }
			}
		}

		function getDataForElasticSearch() {
			MessageInboxService.searchMessageInbox(vm.model.searchCriteria, function(newMessageData) {
				MessageInboxService.appendToGridMessageList(vm.model.messagesData,
						MessageInboxFactory.getFormattedMessageList(newMessageData, vm.prioritiesList));
			}, function(error) {
				MessageService.error(error);
			});

		}

		// get master data list
		(function() {

			CommonMasterData.getMessageSentByList(function (sentByList) {
                vm.model.masterList.sentByList = sentByList;
            }, function (error) {})

            CommonMasterData.getMessagePrioritiesList(function(
					messagePriorities) {
				vm.prioritiesList = messagePriorities;
			}, function() {
				console.log('Message Priorities list retrieval error');
			});

            CommonMasterData.getMessageCategoryList(function (messageCategoryList) {
                vm.model.masterList.messageCategoryList = messageCategoryList;
            }, function (error) {})

            getMaxCharCountInSentMsg();

		})();
	}
}());
